$(document).ready(function () {
  $(document).on('click', '.clr-btn', function() {
      const variantColor = $(this).attr('data-variant-color');
      $('#selected-variant-color').val(variantColor);

      $(this).closest('.box-inner').find('.product-detail-link').each(function () {
        const originalUrl =  $(this).attr('data-parent-url');
        const newUrl = originalUrl + (originalUrl.indexOf('?') !== -1 ? '&' : '?') + 'color=' + encodeURIComponent(variantColor);
        $(this).attr('href', newUrl);
      });
  });
  
  
	function validateField(field) {
		var validation = false;

		if (field.attr('type') == 'email') {
			validation = validateEmail(field);
		} else if (field.attr('type') == 'password') {
			validation = validatePassword(field);
		} else if (field.attr('type') == 'text') {
			validation = validateText(field);
		} else if (field[0]['localName'] === 'select') {
			validation = validateSelect(field);
		} else if (field.attr('type') == 'tel') {
			validation = validatePhone(field);
		} else if (field.attr('type') == 'checkbox') {
			validation = validateCheckbox(field);
		} else if (field.attr('type') == 'file') {
			validation = validateFileUpload(field);
		}

		if (validation) {
			field.next('.form-validation-error').remove();
		}

		return validation;
	}

	function validateEmail(field) {
		if (!emptyCheck(field)) {
			return false;
		}

		const email = field.val()

		function invalidEmail() {
			field.next('.form-validation-error').remove();
			$('<span class="form-validation-error">Please enter a valid email address</span>').insertAfter(field);
		}

		const emailParts = email.split('@');

		if (emailParts.length != 2) {
			invalidEmail();
			return false;
		}

		const localPart = emailParts[0];
		const domainPart = emailParts[1];
		const regex = /^[a-zA-Z0-9!#$%&'*+\-/=?^_`{|}~]+(\.[a-zA-Z0-9!#$%&'*+\-/=?^_`{|}~]+)*$/;

		if (!regex.test(localPart) || localPart.length > 64 || localPart.startsWith('.') || localPart.endsWith('.') || localPart.includes('..')) {
			invalidEmail();
			return false;
		}

		if (domainPart.includes('--') || domainPart.startsWith('-') || domainPart.endsWith('-') || domainPart.length > 255) {
			invalidEmail();
			return false;
		}

		const tldRegex = /^[a-zA-Z]{2,}$/;
		const domainParts = domainPart.split('.');
		const domainNameRegex = /^[a-zA-Z0-9]+([-][a-zA-Z0-9]+)*$/;

		if (!domainNameRegex.test(domainParts[0])) {
			invalidEmail();
			return false;
		}

		if (
			domainParts.length < 2 ||
			!tldRegex.test(domainParts[domainParts.length - 1])
		) {
			invalidEmail();
			return false;
		}

		for (let i = 0; i < domainParts.length - 1; i++) {
			if (!domainNameRegex.test(domainParts[i])) {
				invalidEmail();
				return false;
			}
		}

		field.next('.form-validation-error').remove();
		return true;
	}

	function validatePassword(field) {
		if (field.hasClass('validate-password')) {
			if (field.val() !== '' && (field.val().length < 5 || field.val().length > 40)) {
				$('<span class="form-validation-error">Password must be between 5 and 40 characters long.</span>').insertAfter(field);
				return false;
			}
		}

		return emptyCheck(field);
	}

	function validateText(field) {
		if (
			field.val().length < 3 &&
			field.val() !== '' &&
			field.hasClass('min-3-characters')
		) {
			field.next('.form-validation-error').remove();
			$('<span class="form-validation-error">Please enter at least 3 characters</span>').insertAfter(field);
			return false;
		}

        if(
            field.val().length > 40 &&
            field.val() !== '' &&
			field.hasClass('max-40-characters')
        )
        {   field.val(field.val().substring(0, 40));
			field.next('.form-validation-error').remove();
			$('<span class="form-validation-error">Maximum of 40 characters allowed</span>').insertAfter(field);
			return false;
		}
		return emptyCheck(field);
	}

	function validateSelect(field) {
		return emptyCheck(field);
	}

	function validatePhone(field) {
		if (!emptyCheck(field)) {
			return false;
		}

		const phone = field.val();

		function invalidPhone() {
			field.next('.form-validation-error').remove();
			$('<span class="form-validation-error">Please enter a valid phone number</span>').insertAfter(field);
		}

		if (phone.length < 6 || phone.length > 14) {
			invalidPhone();
			return false;
		}

		return true;
	}

	function validateCheckbox(field) {
		return emptyCheck(field);
	}

	function validateFileUpload(field) {
		if (!emptyCheck(field)) {
			return false;
		}

		if (field[0].files.length != 0) {
			var fileName = field[0].files[0].name;

			var uploadFileName = field.closest('.upload-wrapp').find('.upload-text');

			if (fileName != '') {
				uploadFileName.text(fileName);

				uploadFileName.addClass('upload-text-color');

				var fileSize = field[0].files[0].size;

				var fileSizeMB = fileSize / (1024 * 1024);

				if (fileSizeMB > 2) {
					field.next('.form-validation-error').remove();

					$('<span class="form-validation-error">The uploaded file is too large.</span>').insertAfter(field);

					return false;
				} else {
					return true;
				}
			}
		}
	}

	$('#customer_login input, #create_customer input, .edit-address input, #recover_customer_password input, .newsletter-form input, #ContactForm input:not([type="checkbox"]), #ContactForm textarea, #resetPassword input, #address_form_new input').on('keypress', function (e) {
		// if ($(this).attr('type') == 'password' && e.key === ' '){ 
		//   $(this).next('.form-validation-error').remove();
		//   setTimeout(() => {
		//     const value = $(this).val();
		//     if (value.startsWith(' ') || value.endsWith(' ')) {
		//       // Display the error message
		//       $('<span class="form-validation-error">Password starts or ends with spaces</span>').insertAfter($(this));
		//     } else {
		//       // Optionally remove the error message if spaces are corrected
		//       $(this).next('.form-validation-error').remove();
		//     }
		//   }, 0);
		// }else{

		let trimmedValue = $(this).val().trim();
		let inputValue = $(this).val();

		if (!trimmedValue.replace(/\s/g, '').length) {
			$(this).val('');
		}

		if (e.key === ' ' && trimmedValue.length === 0) {
			e.preventDefault();
			$(this).val('');
		}

		if (trimmedValue.length < inputValue.length) {
			if (/^\s/.test(inputValue)) {
				$(this).val(trimmedValue);
			}
		}


		if ($(this).attr('type') === 'text' && $(this).attr('data-field') !== 'zip') {
			let trimmedValue = $(this).val().trim();

			// Check if the pressed key is a letter (excluding numbers and special characters)
			let isLetter = /^[a-zA-Z]+$/.test(e.key);

			// If the pressed key is not a letter and the input value is empty
			if (!isLetter && trimmedValue.length === 0) {
				e.preventDefault();
				$(this).val('');
			}
		}

		if ($(this).attr('type') === 'tel') {
			let trimmedValue = $(this).val().trim();

			// Check if the pressed key is a numbers (excluding numbers and special characters)
			let isNumber = /^[0-9]+$/.test(e.key);
			// let isNumber = /^[0-9+]+$/.test(e.key);
			// isNumber = isNumber.replace(/\+{2,}/g, '+');
			// If the pressed key is not a letter and the input value is empty
			if (!isNumber) {
				e.preventDefault();
				$(this).val('');
			}
		}

		var myArray = ['password', 'file'];
		if ($.inArray($(this).attr('type'), myArray) != 0) {
			var sanitizedValue = inputValue.replace(/\s{2,}/g, ' ') // Replace consecutive spaces with a single space

			$(this).val(sanitizedValue);
		}

		if ($(this).hasClass('required')) {
			if ($(this).val() == '') {
				emptyCheck($(this));
			} else {
				$(this).next('.form-validation-error').remove();

				if ($(this).attr('type') === 'email') {
					validateEmail($(this));
				} else if ($(this).attr('type') === 'tel') {
					validatePhone($(this));
				} else if ($(this).attr('type') === 'text') {
					validateText($(this));
				} else if ($(this).attr('type') == 'file') {
					validateFileUpload($(this));
				} else if ($(this).attr('type') == 'password') {
					validatePassword($(this));
				}
			}
		} else if (!$(this).hasClass('required') && $(this).val() !== '') {
			if ($(this).attr('type') === 'email') {
				validateEmail($(this));
			} else if ($(this).attr('type') === 'tel') {
				validatePhone($(this));
			} else if ($(this).attr('type') === 'text') {
				validateText($(this));
			} else if ($(this).attr('type') == 'file') {
				validateFileUpload($(this));
			}
		}
	});


	$("input:not([type='file']).required, select.required, textarea.required").on('focusout', function () {
		emptyCheck($(this));
	});

	$('select').on('change', function () {
		if ($(this).val() !== '') {
			$(this).next('.form-validation-error').remove();
		}
	});

	function emptyCheck(field) {
		let fieldName = ''
		fieldName = field.attr('data-label');

		if ((field.val() === '' || field.val() === null) && field.hasClass('required')) {
			field.next('.form-validation-error').remove();
			if (fieldName) {
				fieldName = fieldName.replace('*', '');
			}

			// if (field.attr('name') === 'courses') {
			//     fieldName = 'Course';
			// } else if (fieldName === '' || fieldName === undefined) {
			//     fieldName = 'This field';
			// }

			$('<span class="form-validation-error">' + fieldName + ' is required</span>').insertAfter(field);
			return false;
		} else {
			return true;
		}
	}

	$('#customer_login button, #create_customer button, .edit-address button:not([type="reset"]), .newsletter-form button[type="submit"], #recover_customer_password button, #ContactForm button[type="submit"], #resetPassword button,  #address_form_new button, .edit-address button.update-address').on('click', function (e) {
		var validated = false;
		var validationSuccess = true;
		var flag = 0;

		$(this).closest('form').find('input.required:not([type="hidden"]):not([type="submit"]), textarea.required, select.required').each(function () {
			validated = validateField($(this));
			if (!validated) {
				validationSuccess = false;
				if (flag == 0) {
					$(this).focus();
					flag = 1;
				}
			}
		})

		if (!validationSuccess) {
			e.preventDefault();
		}
	});
          let selectedColor =null;
	$(document).on('click', '.product-color span', function () {
        if(!$(this).hasClass('active')) {
            $(this).closest('.product-color').find('span').removeClass('active');
            $(this).addClass('active');

            let _this = $(this);
            let newImageUrl = _this.attr('data-image-url');
            // let price = _this.attr('data-price');
          selectedColor =  _this.attr('data-variant-color');
            let img = _this.closest('.product-box').find('.res-image img.res-img-loaded:not(.hongo-alternate-image)');
            // let price_element = _this.closest('.product-box').find('.product-price .price');

            if(newImageUrl != ''){
				_this.closest('.product-box').find('.res-image').addClass("pro-img-loading");

				$("<img>").on("load", function () {
						img.attr("srcset", '');
						img.attr("src", newImageUrl);


                  


                      
						_this.closest('.product-box').find('.res-image').removeClass("pro-img-loading"); // Remove loading indicator
						// price_element.text(price);
					}).on("error", function () {
						// Handle image loading error (optional)
						console.error("Error loading image:", newImageUrl);
						// You can display an error message or use a default image here
					})
					.attr("src", newImageUrl); // Start loading the new image asynchronously
			}
        }
	});

	// if ($("body").find(".search-type-3").length > 0) {
	// 	$(".search-type-3").on("click", function () {
	// 		setTimeout(function () {
    //             var searchIcon = document.getElementById("search-icon");
    //             var searchBar = document.getElementById("search-bars");
            
    //             // Toggle search bar visibility
    //             if (searchBar.style.display === "none" || searchBar.style.display === "") {
    //                 searchBar.style.display = "flex";
    //                 searchIcon.classList.add("close-search-icon");
    //             } else {
    //                 searchIcon.classList.remove("close-search-icon");
    //                 searchBar.style.display = "none";
    //             }

	// 			$(".search-results-wrapper").addClass("active").attr("aria-label", "search result menu is opened");
	// 			$("body").addClass("search-active stop-scroll-ui");
	// 			$('html').addClass("stop-scroll-ui");
	// 		}, 50);
	// 	});
	// }

	// $('.search-close-btn').on('click', function () {
	// 	// setTimeout(function () {
    //         var searchIcon = document.getElementById("search-icon");
    //         var searchBar = document.getElementById("search-bars");

    //         // Hide the search bar
    //         searchBar.style.display = "none";
    //         searchIcon.classList.remove("close-search-icon");

	// 		$(".search-results-wrapper").removeClass("active").attr("aria-label", "search result menu is closed");
	// 		$("body").removeClass("search-active stop-scroll-ui");
	// 		$('html').removeClass("stop-scroll-ui");
	// 	// }, 50);
	// });

	// $(document).on("click", "body", function (e) {
	// 	var clickedOutside = $(e.target);
	// 	if (!clickedOutside.parents().andSelf().is("#form-minisearch, .search-results-inner")) {
	// 		$(".search-results-wrapper").removeClass("active");
	// 		$("body").removeClass("search-active");

	// 		var searchIcon = document.getElementById("search-icon");
    //         var searchBar = document.getElementById("search-bars");

    //         // Hide the search bar
    //         searchBar.style.display = "none";
    //         searchIcon.classList.remove("close-search-icon");

	// 		$(".search-results-wrapper").removeClass("active").attr("aria-label", "search result menu is closed");
	// 		$("body").removeClass("search-active stop-scroll-ui");
	// 		$('html').removeClass("stop-scroll-ui");
	// 	}

	// 	if (!clickedOutside.parents().andSelf().is(".cart-notification__content, .minicart-toggler")){
	// 		const cartNotification = document.querySelector("cart-notification");
	// 		if($('.cart-notification').hasClass('active')){
	// 			cartNotification.close();
	// 			if($('.product-form-buttons').length){
	// 				$('.product-form-buttons .quantity-input').attr('value', 1).trigger('change');
	// 			}
	// 		}
	// 	}
	// });


	// $(document).on('click', '.product-color span', function () {
    //     if(!$(this).hasClass('active')) {
    //         $(this).closest('.product-color').find('span').removeClass('active');
    //         $(this).addClass('active');

    //         let _this = $(this);
    //         let newImageUrl = _this.attr('data-image-url');
    //         let price = _this.attr('data-price');
    //         let img = _this.closest('.product-card-outer').find('.img-wrap img');
    //         let price_element = _this.closest('.product-card-outer').find('.product-price .price');

            
    //         _this.closest('.product-card-outer').find('.img-wrap').addClass("pro-img-loading");

    //         $("<img>") // Create a new temporary image element
    //             .on("load", function () {
    //                 img.attr("src", newImageUrl);
    //                 console.log('in');
    //                 _this.closest('.product-card-outer').find('.img-wrap').removeClass("pro-img-loading"); // Remove loading indicator
    //                 price_element.text(price);
    //             })
    //             .on("error", function () {
    //                 // Handle image loading error (optional)
    //                 console.error("Error loading image:", newImageUrl);
    //                 // You can display an error message or use a default image here
    //             })
    //             .attr("src", newImageUrl); // Start loading the new image asynchronously
    //     }
	// });

	// setTimeout(() => {
	// 	$('.st-wishlist-button').each(function () {
	// 		if ($(this).hasClass('st-is-added')) {
	// 			$(this).closest('div.like-icon').addClass('active');
	// 		}
	// 	});
	// }, 1000);


	// Function to append stretched link to .st-product-card
    // function appendStretchedLink(element) {
    //     var page_url = $(element).find('.st-product-card_title a').attr('href');
    //     if (page_url) {
    //         $(element).append('<a class="stretched-link" href="' + page_url + '"></a>');
    //     }
    // }

    // Observer to detect changes in the container
    // var observer = new MutationObserver(function(mutations) {
    //     mutations.forEach(function(mutation) {
    //         if (mutation.type === 'childList') {
    //             $(mutation.addedNodes).each(function() {
    //                 if ($(this).hasClass('st-product-card')) {
    //                     appendStretchedLink(this);
    //                 }
    //                 // If there are nested elements within the added nodes
    //                 $(this).find('.st-product-card').each(function() {
    //                     appendStretchedLink(this);
    //                 });
    //             });
    //         }

	// 		if ($('#st-wishlist-page .st-page_products').is(':empty')) {
	// 			$('#st-wishlist-page .st-page_controls').addClass('d-none');
	// 		}else{
	// 			$('#st-wishlist-page .st-page_controls').removeClass('d-none');
	// 		}
			
	// 		$('.st-wishlist-button').each(function () {
	// 			if ($(this).hasClass('st-is-added')) {
	// 				$(this).closest('div.like-icon').addClass('active');
	// 			}
	// 		});
    //     });
    // });

    // Configuring the observer to watch for added nodes
    // var config = { childList: true, subtree: true };

    // Start observing the container element
    // var targetNode = document.getElementById('st-wishlist-page');
    // if (targetNode) {
    //     observer.observe(targetNode, config);
    // }

	// $('#form-minisearch').on('submit', function(){
	// 	if($(this).find('#searchField').val() == ''){
	// 		return false;
	// 	}
	// });

	// document.getElementById("search-icon").addEventListener("click", () => {
	// 	setTimeout(() => {
	// 		document.getElementById("searchField").focus();
	// 	}, 100);
	// });

	$('.user-logout').on('click', function (event) {
		var confirmation = confirm("Are you sure you want to log out?");

		if (!confirmation) {
			event.preventDefault();
		}
	});

	// if ($('#st-wishlist-page .st-page_products').is(':empty')) {
	// 	$('#st-wishlist-page .st-page_controls').addClass('d-none');
	// }
	
});

$('#form-minisearch').on('submit', function(){
	if($(this).find('.search-type-2').val() == ''){
		return false;
	}
});



setInterval(function(){
	if($('.filter_wrapper').length){
		$('.filter_wrapper .js-filter').each(function() {
			var _this = $(this);
			var i = 0; // Initialize i here, at the start of each .js-filter iteration
			if(_this.find('.filter-list li').length){
				_this.find('.filter-list li').each(function() {
					var __this = $(this);
					if(__this.find('label').hasClass('disabled')){
						// do nothing
					} else {
						i++;
					}
				});
				if(i == 0){
					_this.addClass('d-none');
				} else {
					_this.removeClass('d-none');
				}
			}
		});
	}
}, 500);

setInterval(function(){
	if($('body').hasClass('index-page')){
		$('.new-arrival-section .col.product-box').each(function(){
			var _this = $(this);
			if(_this.find('.parent-product').attr('data-remove') == 'true'){
				_this.remove();
			}

		});
		
	}
}, 100);

$(window).on('load', function() {
    if ($('body').hasClass('product-page')) {
		console.log('bodyIn');
		
        if ($('variant-radios').length) {console.log('variant-radios');
            // Function to get query parameters from the URL
            function getQueryParam(param) {
                var urlParams = new URLSearchParams(window.location.search);
                return urlParams.get(param);
            }

            // Get the color from the URL
            var colorInUrl = getQueryParam('color');
			console.log('colorInUrl', colorInUrl);
			

            // Select variant options
            var variantOptions = $('.product-variants .product-filter:first .variant-option');

            // If color is present in the URL and is not empty, select that color
            if (colorInUrl && colorInUrl.trim() !== "") {
                var selectedVariant = variantOptions.filter(function() {
                    return $(this).data('option-name').toLowerCase() === colorInUrl.toLowerCase();
                });

				console.log('selectedVariant', selectedVariant.find('label'));
				

                setTimeout(function() {
                    if (selectedVariant.length) {
                        selectedVariant.find('label').trigger('click');
                    } else if (variantOptions.length > 0) {
                        // If the color from the URL isn't found, select the first available variant
                        $(variantOptions.first()).find('label').trigger('click');
                    }
                }, 1850); // Delay for 10 seconds (10000 milliseconds)
            } else if (variantOptions.length > 0) {
                // If no color is specified in the URL or it's empty, select the first available variant
                setTimeout(function() {
                    $(variantOptions.first()).find('label').trigger('click');
                }, 2000); // Delay for 10 seconds
            }
        }
    }
});



// like icon click fn

// setTimeout(()=>{
// 	$(document).on('click', '.like-icon', function() {
// 		var _this = $(this);
// 		var handle = _this.find('.st-wishlist-button').attr('data-handle');
// 		var matchingButtons = $(document).find('.st-wishlist-button[data-handle="' + handle + '"]');
// 		_this.addClass('pe-none');
// 		if (_this.hasClass('active')) {
// 		  _this.removeClass('active');
// 		  matchingButtons.not(_this.find('.st-wishlist-button')).toggleClass('st-is-added');
// 		  matchingButtons.not(_this.find('.st-wishlist-button')).closest('div.like-icon').toggleClass('active');
// 		} else {
// 		  _this.addClass('active');
// 		  matchingButtons.not(_this.find('.st-wishlist-button')).toggleClass('st-is-added');
// 		  matchingButtons.not(_this.find('.st-wishlist-button')).closest('div.like-icon').toggleClass('active');
// 		}

// 		setTimeout(function(){
// 			_this.removeClass('pe-none');
// 		},2500);

// 	});
	  
// },100)

// jQuery(window).on('load', function(){
// 	setTimeout(function(){
// 		setInterval(function(){
// 			var getValue = parseInt($(document).find('#cart-notification-content .cart-count').text());
// 			if(getValue > 0){
// 				$(document).find('.minicart-toggler .cart-text span').text(parseInt($(document).find('#cart-notification-content .cart-count').text()));
// 			} else {
// 				$(document).find('.minicart-toggler .cart-text span').text(0);
// 			}
// 		}, 100);
// 	}, 5000);

// 	setInterval(function(){
// 		$(document).find('.st-wishlist-button').each(function(){
// 			if($(this).hasClass('st-is-added')){
// 				$(this).closest('.like-icon').addClass('active');
// 			}
// 		});
// 	}, 100);
// });